
const loginType = { label: '集团用户', value: 'sso' }

const userType = '01';

const clientId = 'HXWS';

function getHost() {
  //   // 基于域名判断环境，不依赖NODE_ENV（测试环境用npm run build部署时NODE_ENV=production会导致走生产SSO）
  // const hostname = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
  // if (hostname.indexOf('hxwstest') !== -1 || hostname.indexOf('test') !== -1) {
  //   return 'https://testsso.cncecoa.com:48080';
  // }
  if (process.env.NODE_ENV === 'production') {
    return 'https://sso.cncecoa.com';
  } else {
    return 'https://testsso.cncecoa.com:48080';
  }
}

// function getRedirectUrl() {
//   let hostUrl 
//    if (process.env.NODE_ENV === 'production') {
//     hostUrl = 'https://fa.cncecoa.com/foreign/#'
//    }else {
//      hostUrl = 'https://hxwstest.cncecoa.com:15145/foreign/#'
//    }
//   return hostUrl + '/index'
// }
// // 获取重定向地址
function getRedirectUrl() {
  // alert(JSON.stringify(window.location))
  const { origin, pathname, search, hash } = window.location;
  const params = new URLSearchParams(search);

  params.delete('code');
  params.delete('state');

  const query = params.toString();
  return `${origin}${pathname}${hash}${query ? `?${query}` : ''}`;
}
function getLoginUrl() {
  //if (process.env.NODE_ENV !== 'production') return 'http://localhost:8005/#/index?logintest=wangqun6%40cncec'
  return `${getHost()}/idp/oauth2/authorize?redirect_uri=${encodeURIComponent(getRedirectUrl())}&state=${userType}&client_id=${clientId}&response_type=code`;
}

function getLogoutUrl() {
  return `${getHost()}/idp/profile/OAUTH2/Redirect/GLO?redirctToUrl=${encodeURIComponent(getRedirectUrl())}&redirectToLogin=true&entityId=${clientId}`;
}

function getTicketKey() {
  return 'code';
}

function getUserTypeKey() {
  return 'state';
}

export default {
  loginType,
  userType,
  clientId,
  getLoginUrl,
  getTicketKey,
  getUserTypeKey,
  getLogoutUrl
}
